export default "__VITE_ASSET__COYLjT3i__"